import { Route, Routes } from "react-router-dom";
import TechinicalList from "./TechinicalList";
import TechinicalForm from "./TechinicalForm";
import TechinicalGenarateDocument from "./TechinicalGenarateDocument";

const TechinicalRoutes = () => {
  return (
    <Routes>
      <Route index element={<TechinicalList />} />
      <Route path="new" element={<TechinicalForm />} />
      <Route path="edit/:id" element={<TechinicalForm />} />
      <Route path="generate/:id" element={<TechinicalGenarateDocument />} />
    </Routes>
  );
};

export default TechinicalRoutes;
